interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articleData?: {
    publishedAt?: string;
    modifiedAt?: string;
    author?: string;
    tags?: string[];
  };
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, articleData }: SEOHeadProps) {
  useEffect(() => {
    const originalTitle = document.title;

    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    setMeta('og:type', ogType, true);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    if (ogImage) setMeta('twitter:image', ogImage);

    if (canonicalUrl) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    if (articleData?.publishedAt) {
      let metaEl = document.querySelector('meta[property="article:published_time"]');
      if (!metaEl) {
        metaEl = document.createElement('meta');
        metaEl.setAttribute('property', 'article:published_time');
        document.head.appendChild(metaEl);
      }
      metaEl.setAttribute('content', articleData.publishedAt);

      if (articleData.modifiedAt) {
        let modEl = document.querySelector('meta[property="article:modified_time"]');
        if (!modEl) {
          modEl = document.createElement('meta');
          modEl.setAttribute('property', 'article:modified_time');
          document.head.appendChild(modEl);
        }
        modEl.setAttribute('content', articleData.modifiedAt);
      }

      if (articleData.author) {
        let authorEl = document.querySelector('meta[property="article:author"]');
        if (!authorEl) {
          authorEl = document.createElement('meta');
          authorEl.setAttribute('property', 'article:author');
          document.head.appendChild(authorEl);
        }
        authorEl.setAttribute('content', articleData.author);
      }
    }

    return () => {
      document.title = originalTitle;
    };
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, articleData]);

  return null;
}